import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { GetLatestInternalAuditReportRiskAssessmentResultsByRiskIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetLatestInternalAuditReportRiskAssessmentResultsByRiskId as useGetLatestInternalAuditReportRiskAssessmentResultsByRiskIdTRPC } from './useGetLatestInternalAuditReportRiskAssessmentResultsByRiskIdTRPC';

export const useGetLatestInternalAuditReportRiskAssessmentResultsByRiskId = (
  riskId: string,
  skip?: boolean
) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
    error: graphqlError,
  } = useQuery(
    GetLatestInternalAuditReportRiskAssessmentResultsByRiskIdDocument,
    {
      variables: {
        RiskId: riskId,
      },
      skip: trpcEnabled || skip, // Skip GraphQL query when TRPC is enabled
      fetchPolicy: 'no-cache',
      onError: (error) => {
        if (!trpcEnabled) {
          addNotification({
            type: 'error',
            content: <>{error.message}</>,
          });
        }
      },
    }
  );

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
    error: trpcError,
  } = useGetLatestInternalAuditReportRiskAssessmentResultsByRiskIdTRPC(
    riskId,
    skip
  );

  // Return appropriate data based on feature flag
  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: () => trpcRefetch(),
      error: trpcError,
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => graphqlRefetch(),
    error: graphqlError,
  };
};
